import React from "react";

interface SourceLinkProps {
    label?: string;
    onClick?: () => void;
}

const SourceLink: React.FC<SourceLinkProps> = ({
    label = "See data 2023-2024",
    onClick
}) => {
    return (
        <p className="ms-3 text-end source source-data-link "
        >
            <a
                className="fw-bold source source-data-link pointer"
                style={{ textDecoration: "none", cursor: "pointer" }}
                target="_blank"
                rel="noopener noreferrer"
                onClick={onClick}
            >
                {label}
            </a>
        </p>
    );
};

export default SourceLink;
